import * as React from 'react';
import { ComplexValue, FavouriteReplaceDomainNodes, LoadOptions } from 'app/types-shared';
import { SelectMultipleHierarchy } from 'app/area/shared/translated-components';
import { FiltersTranslation } from 'app/area/filters/constants';

export interface FilterReplacementsRemoveFiltersSelectProps {
  valueItems: ComplexValue<number>[];
  replaceDomainNodes: FavouriteReplaceDomainNodes[];
  removeDomainNodeOptions: ComplexValue<number>[];
  optionsIds: number[];
  onChange: (valueItem: ComplexValue<number>[]) => void;
  onLoadRemoveNodesFields: ({ optionsIds, query }: {
    optionsIds?: number[];
    query?: string;
  }) => void;
  translation: FiltersTranslation;
  locale: string;
}

export interface RemoveFiltersSelectState {
  loadOptions: LoadOptions;
  isFetching: boolean;
}

export class FilterReplacementsRemoveFiltersSelect extends React.Component<FilterReplacementsRemoveFiltersSelectProps,
  RemoveFiltersSelectState> {

  public state: Readonly<RemoveFiltersSelectState> = {
    loadOptions: undefined,
    isFetching: false
  };

  public componentDidUpdate(prevProps: FilterReplacementsRemoveFiltersSelectProps) {

    if (this.props.removeDomainNodeOptions !== prevProps.removeDomainNodeOptions) {
      this.setState({ isFetching: false });
    }
  }

  private onLoadOptions = (loadOptions: LoadOptions) => {
    this.setState({ loadOptions, isFetching: true }, () => {
      this.props.onLoadRemoveNodesFields({ optionsIds: this.props.optionsIds, query: loadOptions.query });
    });
  };

  public render() {
    const { valueItems, removeDomainNodeOptions, translation, locale, onChange } = this.props;

    return (<SelectMultipleHierarchy
      componentId={'remove-filters-select'}
      className={'multiple-hierarchy'}
      placeholder={translation && translation.filters_search_placeholder}
      valueItems={valueItems}
      loadOptions={this.state.loadOptions}
      options={removeDomainNodeOptions}
      onChange={onChange}
      onLoadOptions={this.onLoadOptions}
      fetching={this.state.isFetching}
      alwaysOpen={true}
      leafNodeOnly={true}
      descriptionAllLevels={true}
      locale={locale} />);
  }
}
